<template>
    <div v-if="$store.state.readyState" class="launch">
        <div class="wrapper">
            <div v-if="missionReady" class="launch__hero launch__hero--mission">
                <div class="launch__hero-card launch__hero-card--mission">
                    <h2 class="launch__title">{{mission.mission_name}}</h2>
                    <p>{{mission.description}}</p>
                    <div class="launch__hero-icons">
                        <a target="_blank" :href="mission.website" class="launch__hero-icon">
                            <img src="../assets/world.svg" alt="">
                            <span>Website</span>
                        </a><!-- /.launch__hero-icon -->
                        <a target="_blank" :href="mission.wikipedia" class="launch__hero-icon">
                            <img src="../assets/world.svg" alt="">
                            <span>Wikipedia Page</span>
                        </a><!-- /.launch__hero-icon -->
                    </div><!-- /.launch__hero-icons -->
                </div><!-- /.misson__hero-card -->
                <div class="">
                    <div v-if="launches" class="launches launches--mission">
                        <LaunchCard v-for="(launch, index) in launches" :key="index" :launch="launch"/>
                    </div><!-- /.launches -->
                </div>
            </div><!-- /.misson__hero -->
        </div><!-- /.wrapper -->
    </div><!-- /.launch -->
</template>

<script>
import objectFitImages from 'object-fit-images'
import LaunchCard from '@/components/LaunchCard'
import jQuery from 'jquery'
export default {
    name: 'Mission',
    components: {
        LaunchCard
    },
    data() {
        return {
            id: 0,
            mission: null,
            apiUrl: 'https://api.spacexdata.com/v3/missions/',
            missionReady: false,
            //twitterUsername: ''
            launches: ''
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        this.launches = this.$route.params.launches ? this.$route.params.launches : null
        this.mission = this.$route.params.mission ? this.$route.params.mission : null
        if(this.launches == null || this.mission == null) {
            this.mission = this.$store.state.missions.filter(i => i.mission_id === this.id)[0];
            this.launches = this.$store.state.launches.filter((i) => { 
                return i.mission_id[0] === this.id || i.mission_id[1] === this.id
            });
        }
        window.addEventListener('load', () => {
            window.$ = jQuery;
        });
        this.missionReady = true;
        let windowHeight = window.innerHeight;
        if($('#app').innerHeight() > windowHeight) {
            $(window).scrollTo(0);
        }
        
    },
}
</script>

